module.exports = __webpack_public_path__ + "img/cart-x-fill.365cd67f.svg";